export default class Filter {
	parentId: string | null;

	name: string | null;

	hasParent: boolean | null;

	constructor(
		parentId: string | null,
		name: string | null,
		hasParent: boolean | null = parentId !== null || name !== null ? null : false
	) {
		this.parentId = parentId;
		this.name = name;
		this.hasParent = hasParent;
	}

	get key(): string {
		return `${this.parentId}-${this.name}-${this.hasParent}`;
	}
}
